(function () {
  'use strict';
  function createTermsFlow(ui) {
    let pending = null;
    return {
      request(context) {
        if (!context.checkbox || context.checkbox.checked) { ui.proceed(context); return; }
        pending = context;
        ui.open(context);
      },
      accept() {
        if (!pending) return;
        const context = pending;
        pending = null;
        context.checkbox.checked = true;
        ui.change(context.checkbox);
        ui.close(context);
        ui.proceed(context);
      },
      cancel() {
        if (!pending) return;
        const context = pending;
        pending = null;
        ui.close(context);
      }
    };
  }
  if (typeof module !== 'undefined') module.exports = { createTermsFlow };
  if (typeof document === 'undefined') return;
  const dialog = document.getElementById('park-checkout-terms');
  if (!dialog) return;
  // One explicit acceptance per browser-tab session, shared by both cart surfaces.
  const acceptanceKey = 'park:cart-terms:accepted:v1';
  let accepted = false;
  function restoreAcceptance() {
    try { accepted = window.sessionStorage.getItem(acceptanceKey) === 'true'; } catch (_) { /* Keep the in-page state when storage is unavailable. */ }
  }
  function syncTerms(root = document) {
    if (root.matches?.('[data-park-terms]')) root.checked = accepted;
    root.querySelectorAll?.('[data-park-terms]').forEach(checkbox => { checkbox.checked = accepted; });
  }
  restoreAcceptance();
  syncTerms();
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-park-terms]')) return;
    accepted = event.target.checked;
    try {
      if (accepted) window.sessionStorage.setItem(acceptanceKey, 'true');
      else window.sessionStorage.removeItem(acceptanceKey);
    } catch (_) { /* Both visible carts still stay in sync. */ }
    syncTerms();
  });
  // Cart quantity changes replace sections without reloading this script.
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) syncTerms(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', function () { restoreAcceptance(); syncTerms(); });
  let bypass = false;
  const flow = createTermsFlow({
    open() { if (!dialog.open) dialog.showModal(); },
    close(context) { dialog.close(); if (context.button && context.button.isConnected) context.button.focus(); },
    change(checkbox) { checkbox.dispatchEvent(new Event('change', { bubbles: true })); },
    proceed(context) {
      // A cart refresh may replace or lock the checkout control while the popup is open.
      if (!context.button?.isConnected || context.button.getAttribute('aria-disabled') === 'true') return;
      if (context.url) { window.location.assign(context.url); return; }
      if (context.form && context.button && context.button.isConnected) {
        bypass = true;
        try { context.form.requestSubmit(context.button); } finally { bypass = false; }
      }
    }
  });
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-park-checkout]');
    if (!button || bypass) return;
    const scope = button.closest('form, [data-park-terms-scope]');
    const checkbox = scope && scope.querySelector('[data-park-terms]');
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.getAttribute('aria-disabled') === 'true') return;
    flow.request({ button, checkbox, form: button.closest('form'), url: button.dataset.checkoutUrl });
  }, true);
  document.addEventListener('submit', function (event) {
    if (bypass || !event.target.matches('form.cart-form')) return;
    const button = event.submitter;
    if (!button || !button.matches('[data-park-checkout]')) return;
    const checkbox = event.target.querySelector('[data-park-terms]');
    if (checkbox && !checkbox.checked) {
      event.preventDefault(); event.stopImmediatePropagation();
      flow.request({ button, checkbox, form: event.target });
    }
  }, true);
  dialog.querySelector('[data-park-accept]').addEventListener('click', () => flow.accept());
  dialog.querySelector('[data-park-cancel]').addEventListener('click', () => flow.cancel());
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); flow.cancel(); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) flow.cancel(); } });
})();
